/*
 * File: menu.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

// 菜单
// 获取权限列表
export const MENU_AUTH_MEMULIST = '/cmms/activity/team/newList';
// 获取左侧导航
export const MENU_AUTH_MENULIST = '/cmms/auth/newMenuList';
